export default __webpack_public_path__ + "static/media/0_3.48aaff41.png";